import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { BaseSiteService, ClientTokenService, UserIdService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { publishReplay, refCount, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ShimanoLanguageService } from '../language/shimano-language.service';

export interface ManualsPayload {
  fields: string;
  productCode: string;
  productOptions: string;
}

@Injectable({
  providedIn: 'root',
})
export class ManualsService {
  baseSite$: Observable<string> = this.baseService.getActive();
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  url = `${this.occUrl.content}${environment.prefix}${this.baseSiteId}`;
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  private cachedManuals$: any = {};

  constructor(
    private meta: Meta,
    protected http: HttpClient,
    protected auth: UserIdService,
    protected clientToken: ClientTokenService,
    protected baseService: BaseSiteService,
    protected languageService: ShimanoLanguageService
  ) {}
  get baseSiteId(): string {
    let baseSiteId: string;
    this.baseSite$.pipe(take(1)).subscribe((baseSiteData) => (baseSiteId = baseSiteData));
    return baseSiteId;
  }

  get tokenId(): string {
    let tokenId: string;
    this.clientToken
      .getClientToken()
      .pipe(take(1))
      .subscribe((tokenIdData) => (tokenId = tokenIdData.access_token));
    return tokenId;
  }

  get activeLanguage(): string {
    let activeLanguage: string;
    this.languageService.getActive().subscribe((lang) => (activeLanguage = lang));
    return activeLanguage;
  }

  getManuals(payload: ManualsPayload, lang = this.activeLanguage): Observable<any> {
    const params = new HttpParams().set('fields', payload.fields).set('productOptions', payload.productOptions);
    const idString = [payload.productCode, lang].join();

    if (!this.cachedManuals$[idString]) {
      this.cachedManuals$[idString] = this.http
        .get(`${this.url}/products/${payload.productCode}/options`, {
          params,
          headers: this.headers,
        })
        .pipe(publishReplay(), refCount(), take(1));
    }
    return this.cachedManuals$[idString];
  }
}
